import { Enveloppe } from 'app/design/icons/enveloppe';
import { Column, Row } from 'app/design/primitives/box';
import { Button, PressableType } from 'app/design/primitives/button';
import { RemoteError } from 'app/design/primitives/remote-error';
import { Text } from 'app/design/primitives/text';
import { isWhiteLabel } from 'app/utils/helpers';
import { createTheme as createDSTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import type { IntroPageSharedProps } from './intro-page.types';
import { IntroSideCardSlider } from './intro-side-card-slider.large';
import { IntroSSOSection } from './intro-sso-section.large';

const theme = createDSTheme();

export function IntroSignupPage({
  createIdentity,
  didSSOLogin,
  goBackWhenIsLoggedIn,
  onLayoutSSO,
  onPressSignUp,
  onToggleForm,
  refSSO,
  renderPartners,
  renderSSOButtons,
  ssoError,
}: IntroPageSharedProps & { onPressSignUp: () => void }) {
  const { t: tSignup } = useTranslation('signup');
  const { t: tAPI } = useTranslation('api-errors');
  return (
    <Row backgroundColor="surface.tertiary" flex={1}>
      <Column gap="spacing.general.x4" flex={1} justifyContent="center" alignItems="center">
        <View
          style={{
            marginRight: theme.spacing['spacing.general.x12'] + 20,
            marginLeft: theme.spacing['spacing.general.x12'] + 20,
            maxWidth: 520,
            width: '80%',
            gap: theme.spacing['spacing.general.x4'],
            backgroundColor: 'white',
            padding: theme.spacing['spacing.general.x4'],
            borderRadius: theme.borderRadii['radius.lg'],
          }}
        >
          <Text
            fontWeight="700"
            marginBottom="spacing.general.x2"
            style={{ marginHorizontal: 16 + 30 }}
            textAlign="center"
            variant="headerXSmall"
          >
            {tSignup('title')}
          </Text>

          <IntroSSOSection {...{ onLayoutSSO, refSSO, renderSSOButtons, ssoError }} />

          {createIdentity.error ? (
            <RemoteError {...{ error: createIdentity.error, message: tAPI(createIdentity.error.message) }} />
          ) : null}

          <Button
            loading={createIdentity.isPending || (goBackWhenIsLoggedIn && !didSSOLogin)}
            pressableType={PressableType.GestureHandler}
            onPress={onPressSignUp}
            variant="signup"
            style={{ width: '100%' }}
          >
            <Row alignItems="center" justifyContent="center" style={{ gap: theme.spacing['spacing.general.x2'] }}>
              <Enveloppe color={theme.colors['surface.default']} />
              <Text
                flex={1}
                fontWeight="700"
                textAlign="center"
                style={{
                  color: theme.colors['surface.default'],
                  alignItems: 'center',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: 8,
                }}
              >
                {tSignup('signUpWithEmail')}
              </Text>
            </Row>
          </Button>

          <Button onPress={onToggleForm} variant="plain" marginBottom="spacing.general.x5">
            <Row gap="spacing.general.x1">
              <Text color="text.placeholder">{tSignup('alreadyHaveAccountPrefix')}</Text>
              <Text fontWeight="700" textDecorationLine="underline" color="surface.brand.default">
                {tSignup('alreadyHaveAccount')}
              </Text>
            </Row>
          </Button>

          {isWhiteLabel() ? renderPartners() : null}
        </View>
      </Column>
      <IntroSideCardSlider />
    </Row>
  );
}
